import { createAction, props } from '@ngrx/store';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { LicenseAssignToAdmin } from 'mbs-ui-shared@models/License';
import { PermissionFlags } from 'mbs-ui-shared@models/PermissionFlags';
import { StoreTypes } from 'mbs-ui-shared@store/storeTypes.enum';

export const setPermissionFlags = createAction(
  `[${StoreTypes.Licenses}] Set Permission Flags`,
  props<{
    permissionFlags: PermissionFlags;
  }>()
);
export const loadPermissionFlags = createAction(
  `[${StoreTypes.Licenses}] Load Permission Flags`,
  props<{
    force?: boolean;
  }>()
);

export const setBalance = createAction(
  `[${StoreTypes.Licenses}] Set Balance`,
  props<{
    balance: Balance;
  }>()
);
export const loadBalance = createAction(`[${StoreTypes.Licenses}] Load Balance`);

export const setLoading = createAction(`[${StoreTypes.Licenses}] Set Loading`, props<{ loading: boolean }>());

export const loadSubscriptionEditLink = createAction(`[${StoreTypes.Licenses}] Load Subscription EditLink`);
export const setSubscriptionEditLink = createAction(`[${StoreTypes.Licenses}] Set Subscription Edit Link`, props<{ link: string }>());

export const setAssignedLicense = createAction(`[${StoreTypes.Licenses}] Set Assigned License`, props<{ license: LicenseAssignToAdmin }>());

export const invalidateLicenses = createAction(`[${StoreTypes.Licenses}] Invalidate Licenses`);
